export const loader = (
  <div className="loader-container">
    <h4 className="text-theme-green">Please wait...</h4>
    <span className="loader"></span>
  </div>
);
